import React, { useEffect, useState } from "react";
import axios from "axios";

const fmtM = (v) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(v || 0);

const Bloque = ({ titulo, icono, total, href, tono, children }) => (
  <a href={href} className="alerta-card">
    <header><span className={`alerta-icono ${tono}`}><i className={icono} /></span><strong>{titulo}</strong><b>{total}</b></header>
    {children}
  </a>
);

function Alertas() {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL_REPORTES}/alertas`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((r) => setD(r.data)).catch(console.log);
  }, []);
  if (!d) return null;
  return (
    <div className="alertas">
      <Bloque titulo="Vinos por agotarse" icono="fas fa-wine-bottle" total={d.totalBajoStock} href="/ReporteInventario" tono="ambar">
        {d.bajoStock.slice(0, 3).map((v) => <p key={v.vino}>{v.vino}<span>{v.dias === null ? "Agotado" : `${v.dias} dias`}</span></p>)}
      </Bloque>
      <Bloque titulo="Ordenes atrasadas" icono="fas fa-truck-loading" total={d.atrasadas.length} href="/ListadoPendRecibir" tono="rojo">
        {d.atrasadas.slice(0, 3).map((o) => <p key={o.oc}>OC {o.oc} · {o.proveedor}<span>{o.dias} dias</span></p>)}
      </Bloque>
      <Bloque titulo="Notas vencidas" icono="fas fa-file-invoice-dollar" total={d.totalVencidas} href="/ReporteCartera" tono="rojo">
        <p>Saldo vencido<span>{fmtM(d.importeVencido)}</span></p>
        {d.vencidas.slice(0, 2).map((n) => <p key={n.nota}>{n.cliente}<span>{fmtM(n.saldo)}</span></p>)}
      </Bloque>
      <Bloque titulo="Vencen en 7 dias" icono="fas fa-calendar-alt" total={d.porVencer.length} href="/ListadoVentas" tono="azul">
        {d.porVencer.slice(0, 3).map((n) => <p key={n.nota}>{n.cliente}<span>{fmtM(n.saldo)}</span></p>)}
      </Bloque>
      <Bloque titulo="Lotes por caducar" icono="fas fa-tags" total={d.caducidades.length} href="/ListadoLotes" tono="ambar">
        {d.caducidades.slice(0, 3).map((l) => <p key={l.lote}>{l.vino}<span>{l.caducidad}</span></p>)}
      </Bloque>
    </div>
  );
}

export default Alertas;
